import clsx from 'clsx'

import { Flex, Skeleton } from '@buffer-mono/popcorn'

import { PostCardAuthor } from './PostCardAuthor'
import { PostedFrom } from './PostedFrom'
import { PostCardActions } from '../PostCard/PostCardActions'
import { usePostData } from '../PostCard/PostCardContext'

import styles from './PostCardFooter.module.css'

import type { JSX } from 'react'

export type PostCardFooterLayout = 'default' | 'stackedActions'

const PostCardFooterRoot = ({
  condensed = false,
  layout = 'default',
}: {
  condensed?: boolean
  layout?: PostCardFooterLayout
}): JSX.Element | null => {
  const { via } = usePostData()
  const isApiPost = via === 'api' || via === 'buffer'
  const isStackedActions = layout === 'stackedActions'

  return (
    <footer
      className={clsx(
        styles.footer,
        condensed && styles.footerCondensed,
        isStackedActions && styles.stackedActions,
      )}
    >
      {!isStackedActions && (
        <div className={styles.footerMeta}>
          {!isApiPost && !condensed && <PostedFrom />}
          {isApiPost && !condensed && <PostCardAuthor />}
        </div>
      )}
      <PostCardActions
        className={isStackedActions ? styles.stackedActionsWrapper : undefined}
      />
    </footer>
  )
}

PostCardFooterRoot.displayName = 'PostCardFooter'

const PostCardFooterSkeleton = ({
  isSent = false,
}: {
  isSent?: boolean
}): JSX.Element => {
  if (isSent) {
    return (
      <footer className={styles.footer}>
        <Flex justify="end" gap="2xs" className={styles.skeleton}>
          <Skeleton height={32} width={100} />
          <Skeleton height={32} width={32} />
        </Flex>
      </footer>
    )
  }
  return (
    <footer className={styles.footer}>
      <Flex justify="end" gap="2xs" className={styles.skeleton}>
        <Skeleton height={32} width={120} />
        <Skeleton height={32} width={32} />
        <Skeleton height={32} width={32} />
      </Flex>
    </footer>
  )
}

PostCardFooterSkeleton.displayName = 'PostCardFooter.Skeleton'

export const PostCardFooter = Object.assign(PostCardFooterRoot, {
  Skeleton: PostCardFooterSkeleton,
})
